<template>
        <md-dialog :md-active.sync="show">
          <md-dialog-title>Add Template</md-dialog-title>
          <md-dialog-content>
            <form novalidate>
              <md-field :class="getTemplateValidationClass('title')">
                <label for="title">Title</label>
                <md-input name="title" id="title"  v-model="addTemplate.title" />
                  <span class="md-error" v-if="!$v.addTemplate.title.required">The title is required</span>
              </md-field>
              <md-field :class="getTemplateValidationClass('body')">
                <label for="body">Body</label>
                <md-input name="body" id="body"  v-model="addTemplate.body" />
                  <span class="md-error" v-if="!$v.addTemplate.body.required">The body is required</span>
              </md-field>
              <md-field :class="getTemplateValidationClass('link')">
                <label for="link">Link</label>
                <span class="md-prefix">https://</span>
                <md-input name="link" id="link"  v-model="addTemplate.link" />
                  <span class="md-error" v-if="!$v.addTemplate.link.url">The link must be a valid url</span>
              </md-field>
              <md-field :class="getTemplateValidationClass('offset_days')">
                <label for="offset_days">Offset Days of Start Date</label>
                <md-input name="offset_days" id="offset_days"  v-model="addTemplate.offset_days" type="number"/>
                  <span class="md-error" v-if="!$v.addTemplate.offset_days.integer">The days must be a valid number.</span>
              </md-field>
              <md-field :class="getTemplateValidationClass('assignments')">
                <label for="assignments">Send To</label>
                <md-checkbox v-model="addTemplate.assignments" value="Member">Team Member</md-checkbox>
                <md-checkbox v-model="addTemplate.assignments" value="Manager">Manager</md-checkbox>
                <md-checkbox v-model="addTemplate.assignments" value="Mentor">Mentor</md-checkbox>
              </md-field>
            </form>
          </md-dialog-content>
          <md-dialog-actions>
            <md-button class="md-primary" @click="cancel()">Cancel</md-button>
            <md-button class="md-primary" @click="validateTemplate()">Save</md-button>
          </md-dialog-actions>
        </md-dialog>
</template>
<script>
import { validationMixin } from 'vuelidate'
import {
  required,
  integer,
  url
} from 'vuelidate/lib/validators'
export default {
  name: "TemplateDialog",
  mixins: [validationMixin],
  props: {
    show: Boolean
  },
  methods: {
    getTemplateValidationClass (fieldName) {
      const field = this.$v.addTemplate[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    clearTemplateForm () {
      this.$v.$reset()
      this.addTemplate.title = ''
      this.addTemplate.body = ''
      this.addTemplate.link = ''
      this.addTemplate.offset_days = 1
      this.addTemplate.assignments = []
    },
    validateTemplate: function() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.$emit("save", { ...this.addTemplate})
        this.clearTemplateForm()
      }
    },
    cancel: function() {
      this.clearTemplateForm()
      this.$emit("cancel")
    }
  },
  data: function() {
    return {
      addTemplate: {
        title: '',
        body: '',
        link: '',
        offset_days: 1,
        assignments: []
      }
    }
  },
  validations: {
    addTemplate: {
      title: {
        required
      },
      body: {
        required
      },
      link: {
        url
      },
      offset_days: {
        required, 
        integer
      }
    }
  }}
</script>
<style lang="scss" scoped>
.md-checkbox{
  display: flex;
}
</style>
